import { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { useMarket } from "@/market";
import { useLanguage } from "@/i18n";

/* Sélecteur de pays du site public : adapte devise, TVA, prix et arguments. */
export const CountrySwitcher = ({ mobile = false, dark = false }) => {
  const { country, setCountry, countries, market } = useMarket();
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const sfx = mobile ? "-mobile" : "";

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        data-testid={`country-switcher${sfx}`}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t("Pays")}
        onClick={() => setOpen((o) => !o)}
        className={`inline-flex min-h-[36px] items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-bold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#3A5CC8] ${dark ? "border-white/15 bg-white/10 text-white hover:bg-white/15" : "border-[#E2E7F7] bg-white text-[#0F2645] hover:border-[#3A5CC8]"}`}
      >
        <span className="text-base leading-none" aria-hidden="true">{market.flag}</span>
        <span data-testid={`country-switcher-code${sfx}`}>{country}</span>
        <span className={`hidden text-[10px] font-semibold ${dark ? "text-white/70" : "text-[#93A0BC]"} sm:inline`}>{market.currency}</span>
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${open ? "rotate-180" : ""} ${dark ? "text-white/70" : "text-[#93A0BC]"}`} />
      </button>
      {open && (
        <ul role="listbox" data-testid={`country-switcher-menu${sfx}`} className="absolute right-0 z-[60] mt-2 w-60 overflow-hidden rounded-2xl border border-[#E2E7F7] bg-white p-1.5 text-[#0F2645] shadow-[0_24px_50px_-20px_rgba(15,38,69,0.35)]">
          <li className="px-3 pb-1.5 pt-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[#93A0BC]">{t("Votre pays")}</li>
          {countries.map((c) => (
            <li key={c.country} role="option" aria-selected={c.country === country}>
              <button
                type="button"
                data-testid={`country-option-${c.country}${sfx}`}
                onClick={() => { setCountry(c.country); setOpen(false); }}
                className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-left text-sm transition-colors ${c.country === country ? "bg-[#EEF1FC] font-bold" : "hover:bg-[#F6F8FD]"}`}
              >
                <span className="text-lg leading-none" aria-hidden="true">{c.flag}</span>
                <span className="flex-1">{t(c.name)}</span>
                <span className="text-[11px] font-semibold text-[#93A0BC]">{c.currency}</span>
                {c.country === country && <Check className="h-4 w-4 text-[#3A5CC8]" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
